import { CheckCircle } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import { getCustomerFullName } from 'components/customer/customer.utils';
import StringAvatar from 'components/string-avatar/string-avatar.component';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import {
  bindHover,
  bindPopover,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';
import { CustomerStatus } from '../customer.constants';

type CustomerAvatarProps = {
  customer: Partial<Customer>;
};

const size = {
  width: { xs: 40, sm: 80 },
  height: { xs: 40, sm: 80 },
};

const CustomerAvatar = ({ customer }: CustomerAvatarProps) => {
  const { t } = useTranslation();
  const popoverPopupState = usePopupState({
    variant: 'popover',
    popupId: 'search-filter-popup-popover',
  });

  return (
    <Box position="relative">
      {customer?.userProfileImageUrl ? (
        <Avatar
          alt=""
          src={customer?.userProfileImageUrl}
          sx={{ boxShadow: 3, ...size }}
        />
      ) : (
        <StringAvatar
          name={
            getCustomerFullName(customer)
              ? getCustomerFullName(customer)
              : customer?.email
          }
          showBgColor={false}
          sx={{ boxShadow: 3, ...size }}
        />
      )}
      {customer?.status === CustomerStatus.VERIFIED && (
        <Box
          position="absolute"
          bottom={0}
          right={0}
          borderRadius="50%"
          bgcolor="background.paper"
          display="flex"
          alignItems="center"
          justifyContent="center"
          height="fit-content"
          width="fit-content"
        >
          <CheckCircle
            color="info"
            sx={{ margin: '-2px', fontSize: { xs: 16, sm: 24 } }}
            {...bindHover(popoverPopupState)}
          />
          <HoverPopover
            sx={{
              pointerEvents: 'none',
              mt: 1,
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            {...bindPopover(popoverPopupState)}
          >
            <Typography variant="caption" sx={{ px: 1 }}>
              {t('page.customers.card.verifiedEmail')}
            </Typography>
          </HoverPopover>
        </Box>
      )}
    </Box>
  );
};
export default CustomerAvatar;
